import * as React from "react";

import PropTypes from "prop-types";
import { Modal, Button, Icon } from "semantic-ui-react";
import InputComponent from "../../InputComponent";
import styles from "./CancelSubscriptionSubscribersModal.module.css";
import { FaFileUpload, FaSpinner } from "react-icons/fa";

const { useState } = React;

function CancelSubscriptionSubscribersModal({
  visibility,
  onOpenModal,
  onCloseModal,
  onConfirm,
  loading = false,
}) {
  return (
    <Modal
      size="small"
      centered
      open={visibility}
      onOpen={onOpenModal}
      onClose={onCloseModal}
      onConfirm
    >
      <div className={`${styles.modalContainer} flex flex-col`}>
        {loading ? (
          <div className={`flex flex-col justify-center items-center`}>
            <FaSpinner className={`animate-spin`} />{" "}
            <div>Cancelling subscription...</div>
          </div>
        ) : (
          <>
            <Button
              className={styles.closeButton}
              onClick={onCloseModal}
              size="big"
              icon="close"
            />
            <text className={`${styles.headerText} block mb-7`}>
              Are you sure you want to cancel subscription?
            </text>

            <div
              className={`${styles.btnRow} flex items-center justify-center`}
            >
              <button
                onClick={onConfirm}
                className={`${styles.btnGreen} mr-2.5`}
              >
                Yes
              </button>
              <button onClick={onCloseModal} className={`${styles.btnRed}`}>
                No
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}

CancelSubscriptionSubscribersModal.propTypes = {
  visibility: PropTypes.bool.isRequired,
  onOpenModal: PropTypes.func.isRequired,
  onCloseModal: PropTypes.func.isRequired,
};

export default CancelSubscriptionSubscribersModal;
